import { useContextState } from '../../../../../../../hooks/theme'
import { SxProps, Theme } from '@mui/system'

export const getProcessStatusStyles = () => {
  const { colors: color } = useContextState()

  const processStatusLayout: SxProps<Theme> = {
    display: 'flex',
    gap: '16px',
    minHeight: '500px',
    maxHeight: '640px',
    flexWrap: 'wrap',
  }

  const processPanel: SxProps<Theme> = {
    flex: 1,
    minWidth: '300px',
    maxHeight: '640px',
    borderRadius: '4px',
    boxShadow: `0 0 2px 0px ${color.color13}`,
    backgroundColor: '#fff',
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
  }

  const processPanelHeader: SxProps<Theme> = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '26px 20px 0',
    flexWrap: 'wrap',
    gap: '8px',
  }

  const processPanelTitle: SxProps<Theme> = {
    fontSize: '16px',
    fontWeight: 600,
    color: color.color13,
  }

  const processPanelHeaderRight: SxProps<Theme> = {
    fontSize: '14px',
    fontWeight: 500,
    color: color.color13,
  }

  const sliderContainer: SxProps<Theme> = {
    padding: '10px 20px 12px',
    borderBottom: `1px solid ${color.color10}40`,
    backgroundColor: '#fff',
  }

  const applyButton: SxProps<Theme> = {
    fontSize: '13px',
    fontWeight: 500,
    borderRadius: '6px',
    padding: '4px 16px',
    backgroundColor: color.color45,
    color: '#fff',
    '&:hover': {
      backgroundColor: '#1177ad',
    },
  }

  const questionnaireHeader: SxProps<Theme> = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '8px 16px',
    margin: '0 16px',
    marginBottom: '14px',
    borderRadius: '8px',
    cursor: 'pointer',
    border: `1px solid ${color.color10}80`,
    transition: 'all 0.15s ease',
    '&:hover': {
      backgroundColor: '#f9fafb',
    },
  }

  const questionnaireHeaderText: SxProps<Theme> = {
    fontSize: '13px',
    fontWeight: 500,
    color: color.color13,
    flex: 1,
  }

  const questionnaireHeaderArrow: SxProps<Theme> = {
    fontSize: '14px',
    color: color.color9,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  }

  const sectionBarBlue: SxProps<Theme> = {
    position: 'relative',
    backgroundColor: '#4a90e2',
    overflow: 'hidden',
    cursor: 'default',
    display: 'flex',
    alignItems: 'center',
  }

  const sectionBarBlueText: SxProps<Theme> = {
    position: 'relative',
    zIndex: 1,
    fontSize: '13px',
    fontWeight: 600,
    color: '#fff',
    padding: '2px 16px',
    display: 'flex',
    justifyContent: 'space-between',
    width: '100%',
  }

  const questionBarGrayContainer: SxProps<Theme> = {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    gap: '2px',
    padding: '10px 16px 0 16px',
    '&:last-child': {
      paddingBottom: '10px',
    },
  }

  const questionBarGrayLabel: SxProps<Theme> = {
    fontSize: '12px',
    fontWeight: 600,
    color: color.color13,
    minWidth: '90px',
    flexShrink: 0,
  }

  const questionBarGrayTrack: SxProps<Theme> = {
    flex: 1,
    height: '8px',
    borderRadius: '4px',
    backgroundColor: '#e5e7eb',
    overflow: 'hidden',
  }

  const questionBarGrayFill: SxProps<Theme> = {
    height: '100%',
    borderRadius: '4px',
  }

  const questionBarGrayValue: SxProps<Theme> = {
    fontSize: '12px',
    fontWeight: 500,
    color: color.color13,
    minWidth: '36px',
    textAlign: 'right',
    flexShrink: 0,
  }

  const globalProcessRow: SxProps<Theme> = {
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    padding: '8px 16px',
    marginBottom: '4px',
  }

  const globalProcessIndicator: SxProps<Theme> = {
    width: '10px',
    height: '10px',
    borderRadius: '50%',
    flexShrink: 0,
  }

  const globalProcessName: SxProps<Theme> = {
    fontSize: '13px',
    color: color.color13,
    minWidth: '160px',
    flexShrink: 0,
  }

  const globalProcessTrack: SxProps<Theme> = {
    flex: 1,
    height: '10px',
    borderRadius: '5px',
    backgroundColor: '#e5e7eb',
    overflow: 'hidden',
  }

  const globalProcessFill: SxProps<Theme> = {
    height: '100%',
    borderRadius: '5px',
  }

  const globalProcessScore: SxProps<Theme> = {
    fontSize: '13px',
    fontWeight: 500,
    color: color.color13,
    minWidth: '40px',
    textAlign: 'right',
    flexShrink: 0,
  }

  const rightQuestionnaireRow: SxProps<Theme> = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '8px 16px',
    margin: '0 16px',
    marginBottom: '14px',
    borderRadius: '10px',
    cursor: 'pointer',
    border: `1px solid ${color.color10}80`,
    transition: 'all 0.15s ease',
    '&:hover': {
      backgroundColor: '#f9fafb',
    },
  }

  const rightQuestionnaireName: SxProps<Theme> = {
    fontSize: '13px',
    fontWeight: 500,
    color: color.color13,
    flex: 1,
  }

  const rightQuestionnaireBadge: SxProps<Theme> = {
    width: 'auto',
    height: '24px',
    padding: '0 10px',
    borderRadius: '14px',
    color: '#fff',
    fontSize: '13px',
    fontWeight: 600,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  }

  const rightQuestionnaireArrow: SxProps<Theme> = {
    fontSize: '14px',
    color: color.color9,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  }

  const rightSectionRow: SxProps<Theme> = {
    display: 'flex',
    alignItems: 'center',
    padding: '6px 16px',
    marginBottom: '2px',
  }

  const rightSectionLeftColumn: SxProps<Theme> = {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    width: '40%',
    flexShrink: 0,
  }

  const rightSectionRightColumn: SxProps<Theme> = {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    width: '60%',
    flexShrink: 0,
  }

  const rightSectionIndicator: SxProps<Theme> = {
    width: '10px',
    height: '10px',
    borderRadius: '50%',
    flexShrink: 0,
  }

  const rightSectionName: SxProps<Theme> = {
    fontSize: '13px',
    color: color.color13,
    flex: 1,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  }

  const rightSectionTrack: SxProps<Theme> = {
    flex: 1,
    height: '8px',
    borderRadius: '4px',
    backgroundColor: '#e5e7eb',
    overflow: 'hidden',
  }

  const rightSectionFill: SxProps<Theme> = {
    height: '100%',
    borderRadius: '5px',
  }

  const rightSectionScore: SxProps<Theme> = {
    fontSize: '13px',
    fontWeight: 500,
    color: color.color20,
    minWidth: '40px',
    textAlign: 'right',
    flexShrink: 0,
  }

  const toggleButtonGroup: SxProps<Theme> = {
    display: 'flex',
    gap: 0,
    borderRadius: '20px',
    overflow: 'hidden',
    border: '2px solid #22c55e',
    backgroundColor: '#22c55e',
  }

  const toggleButton: SxProps<Theme> = {
    fontSize: '12px',
    fontWeight: 600,
    padding: '6px 16px',
    cursor: 'pointer',
    border: 'none',
    backgroundColor: '#22c55e',
    color: '#fff',
    transition: 'all 0.2s ease',
  }

  const toggleButtonActive: SxProps<Theme> = {
    ...toggleButton,
    backgroundColor: '#fff',
    color: '#1f2937',
  }

  const processDivider: SxProps<Theme> = {
    height: '1px',
    backgroundColor: `${color.color10}40`,
    margin: '12px 16px',
  }

  return {
    processStatusLayout,
    processPanel,
    processPanelHeader,
    processPanelTitle,
    processPanelHeaderRight,
    sliderContainer,
    applyButton,
    questionnaireHeader,
    questionnaireHeaderText,
    questionnaireHeaderArrow,
    sectionBarBlue,
    sectionBarBlueText,
    questionBarGrayContainer,
    questionBarGrayLabel,
    questionBarGrayTrack,
    questionBarGrayFill,
    questionBarGrayValue,
    globalProcessRow,
    globalProcessIndicator,
    globalProcessName,
    globalProcessTrack,
    globalProcessFill,
    globalProcessScore,
    rightQuestionnaireRow,
    rightQuestionnaireName,
    rightQuestionnaireBadge,
    rightQuestionnaireArrow,
    rightSectionRow,
    rightSectionLeftColumn,
    rightSectionRightColumn,
    rightSectionIndicator,
    rightSectionName,
    rightSectionTrack,
    rightSectionFill,
    rightSectionScore,
    toggleButtonGroup,
    toggleButton,
    toggleButtonActive,
    processDivider,
  }
}
